<template>
  <div ref="peLayoutItem" :class="[ns.b()]">
    <div
      ref="peLayoutItemLeft"
      class="el-layout-item-left"
      :style="{ width: props.width }"
    >
      <div v-if="props.noTitle" class="el-layout-item-left-title">
        {{ props.title }}
        <div class="el-layout-item-icon">
          <slot name="title-right" />
        </div>
      </div>
      <div
        ref="peLayoutItemBody"
        class="el-layout-item-left-body"
        :style="{ height: props.noTitle ? 'calc(100% - 48px)' : '100%' }"
      >
        <el-scrollbar
          v-if="props.isScrollbar"
          class="h-full"
          style="overflow-x: hidden"
        >
          <slot name="left" class="h-full" />
        </el-scrollbar>
        <slot v-else name="left" class="h-full" />
      </div>
    </div>
    <div ref="peLayoutItemTrigger" class="el-layout-item-split-trigger" />
    <div ref="peLayoutItemRight" class="el-layout-item-right">
      <slot name="right" class="h-full" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useNamespace } from '@pit-element-plus/hooks'
import { layoutColumnProps } from './layout-column'

const props = defineProps(layoutColumnProps)
const ns = useNamespace('layout-column')
const peLayoutItem = ref()
const peLayoutItemLeft = ref()
const peLayoutItemBody = ref()
const peLayoutItemTrigger = ref()
const peLayoutItemRight = ref()

defineOptions({
  name: 'ElLayoutColumn',
})

onMounted(() => {
  dragControllerDiv()
})

const dragControllerDiv = () => {
  const box = peLayoutItem.value
  const left = peLayoutItemLeft.value
  const resize1 = peLayoutItemTrigger.value
  const middle = peLayoutItemRight.value

  resize1.onmousedown = function (e: { clientX: any }) {
    const initWindowWidth = box.clientWidth
    const initLeftWidth = left.clientWidth
    const initResize1Width = resize1.clientWidth
    const initMiddleWidth = middle.clientWidth
    const mouseStartDistanceToWindowLeft = e.clientX
    // 左边拖拽区域添加mousemove事件，并不断计算各区域宽度
    document.onmousemove = function (e) {
      const mouseFinalDistanceToWindowLeft = e.clientX
      // 获取鼠标移动的距离
      const mouseMovedDistance =
        mouseFinalDistanceToWindowLeft - mouseStartDistanceToWindowLeft
      // 各种计算距离和宽度
      if (initLeftWidth + mouseMovedDistance >= 200) {
        resize1.style.left = initLeftWidth + mouseMovedDistance
        left.style.width = `${initLeftWidth + mouseMovedDistance}px`
        middle.style.left = `${
          initMiddleWidth + mouseMovedDistance + initResize1Width
        }px`
        middle.style.width = `${
          initWindowWidth -
          initLeftWidth -
          initResize1Width -
          mouseMovedDistance
        }px`
      }
    }
    document.onmouseup = function () {
      document.onmousemove = null
      document.onmouseup = null
      resize1.releaseCapture && resize1.releaseCapture()
    }
    resize1.setCapture && resize1.setCapture()
    return false
  }
}
</script>
